import { Transaction } from "../../types/transaction";
import {
    TransactionDto,
    TransactionDtoInput,
} from "../transactions/transaction.dto";
import { TransferPreviewTransactionDto } from "./transfer-preview-transaction.dto";

export interface MatchingTransferDto {
    transaction: TransferPreviewTransactionDto;
    match: TransferPreviewTransactionDto;
}

export interface MatchingTransfer {
    transaction: Transaction;
    match: Transaction;
}

export interface GetRuleMatchingTransfersResponse {
    matches: MatchingTransfer[];
    total: number;
}

export class GetRuleMatchingTransfersResponseDto {
    matches: MatchingTransferDto[];
    total: number;

    constructor(response: GetRuleMatchingTransfersResponse) {
        this.matches = response.matches.map(({ transaction, match }) => ({
            transaction: new TransferPreviewTransactionDto(
                transaction as TransactionDtoInput,
            ),
            match: new TransferPreviewTransactionDto(
                match as TransactionDtoInput,
            ),
        }));
        this.total = response.total;
    }

    static deserialize(
        dto: GetRuleMatchingTransfersResponseDto,
    ): GetRuleMatchingTransfersResponse {
        return {
            matches: dto.matches.map((m) => ({
                transaction: TransactionDto.deserialize(
                    m.transaction,
                ) as Transaction,
                match: TransactionDto.deserialize(m.match) as Transaction,
            })),
            total: dto.total,
        };
    }
}
